import React from "react";

const Address = (props) => {
	const { text, classes } = props;
	return (
		<div
			className={`font-semibold p-1 px-2 rounded-md text-black drop-shadow-lg bg-primary-100 hover:bg-primary-200 transition-all ${
				classes ? classes : ""
			}`}
			>
			{text}
		</div>
	);
};

export default Address;
